<div fxLayout="column">

    <div *ngIf="!!costEstimation.audanetCalculationId">
        <img src="./assets/img/audatex_logo.jpg" [width]='64' alt="audatex_logo" />
    </div>

    <div fxFill fxLayout="column" fxLayoutGap="10px" class="form-block">
        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <div fxFlex="25" fxFlex.lt-sm="100">
                <static-dictionary-select-ctrl [caption]="'claims-center.claimCostEstimations.costEstimationType'"
                    [formControlName]="'costEstimationTypeId'" [staticDictionaryName]="'costEstimationType'"
                    [settings]="{fxFill:true}">
                </static-dictionary-select-ctrl>
            </div>

            <div fxFlex="25" fxFlex.lt-sm="100">
                <static-dictionary-select-ctrl [caption]="'claims-center.claimCostEstimations.costEstimationStatus'"
                    [formControlName]="'costEstimationStatusId'" [staticDictionaryName]="'costEstimationStatus'"
                    [settings]="{fxFill:true}">
                </static-dictionary-select-ctrl>
            </div>

            <div fxFlex="30" fxFlex.lt-sm="100">
                <text-input-ctrl [caption]="'claims-center.claimCostEstimations.titleDescription'"
                    [formControlName]="'titleDescription'" [settings]="{fxFill:true}">
                </text-input-ctrl>
            </div>

            <div fxFlex="10" fxFlex.lt-sm="100">
                <a *ngIf="canHaveAccessToOrderingPartyInfo" role="button" class="clickable"
                    (click)="showOrderingPartyInfo()">
                    {{ 'claims-center.claimCostEstimations.orderingPartyInfo' | translate }}
                </a>
            </div>

        </div>
        <div *ngIf="costEstimation.costEstimationStatusId === 3" fxFlex="90" fxLayout="row wrap" fxLayoutGap="10px"
            fxLayout.lt-sm="column">
            <div fxFlex="16" fxFlex.lt-sm="100">
                <checkbox-input-ctrl [caption]="'claims-center.claimCostEstimations.isPartiallyAccepted'"
                    [formControlName]="'isPartiallyAccepted'">
                </checkbox-input-ctrl>
            </div>

            <div fxFlex="81" fxFlex.lt-sm="100">
                <textarea-input-ctrl [caption]="'claims-center.claimCostEstimations.partiallyAcceptedReason'"
                    [formControlName]="'partiallyAcceptedReason'" [settings]="{rows:1,fxFill:true}">
                </textarea-input-ctrl>
            </div>

        </div>
    </div>

    <div fxFill fxLayout="column" fxLayoutGap="10px" class="form-block">
        <strong>
            {{'claims-center.claimCostEstimations.costEstimationValues' | translate}}
            <span class="k-text-warning" *ngIf="netCheckResult?.mismatch">
                {{'claims-center.claimCostEstimations.nettoValueIsDifferentThanSum' | translate}}
                ({{'claims-center.claimCostEstimations.net' | translate}}: {{ netCheckResult.netValue | number : '1.2-2'
                }}
                {{'claims-center.claimCostEstimations.sum' | translate}}: {{netCheckResult.netSumValue | number :
                '1.2-2' }})
            </span>

        </strong>
        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.pdrLabour'"
                    [formControlName]="'pdrLabour'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.carBodyLabour'"
                    [formControlName]="'carBodyLabour'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.additionalCosts'"
                    [formControlName]="'additionalCosts'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintLabour'"
                    [formControlName]="'paintLabour'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintMaterials'"
                    [formControlName]="'paintMaterials'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100" fxLayout="column">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountAmount'"
                    [formControlName]="'discountAmount'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>

                <checkbox-input-ctrl [caption]="'claims-center.claimCostEstimations.applyDiscountOutOfCostEstimation'"
                    [formControlName]="'applyDiscountOutOfCostEstimation'"
                    (valueChangeEvent)="applyDiscountOutOfCostEstimationChanged()">
                </checkbox-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.vatAmount'"
                    [formControlName]="'vatAmount'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

        </div>

        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.originalParts'"
                    [formControlName]="'originalParts'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.alternativeParts'"
                    [formControlName]="'alternativeParts'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.normalies'"
                    [formControlName]="'normalies'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountForParts'"
                    [formControlName]="'discountForParts'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.netAmount'"
                    [formControlName]="'netAmount'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.deductibleAmount'"
                    [formControlName]="'deductibleAmount'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.finalNetAmount'"
                    [formControlName]="'finalNetAmount'" [settings]="{format:'n2',step:0.01,fxFill:true}">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.grosAmount'"
                    [formControlName]="'grosAmount'" [settings]="{format:'n2',step:0.01,fxFill:true}">
                </numeric-input-ctrl>
            </div>

        </div>
    </div>

    <div fxFill fxLayout="column" fxLayoutGap="10px" class="form-block">

        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
            <strong>{{'claims-center.claimCostEstimations.costEstimationAcceptedValues' | translate}}
                <span class="k-text-warning" *ngIf="acceptedNetCheckResult?.mismatch">
                    {{'claims-center.claimCostEstimations.nettoValueIsDifferentThanSum' | translate}}
                    ({{'claims-center.claimCostEstimations.net' | translate}}: {{ acceptedNetCheckResult.netValue |
                    number : '1.2-2' }}
                    {{'claims-center.claimCostEstimations.sum' | translate}}: {{acceptedNetCheckResult.netSumValue |
                    number : '1.2-2' }})
                </span>
            </strong>
            <button type="button" kendoButton (click)="copyAcceptedValues()" icon="copy" size="'small'" look="flat">
            </button>
        </div>

        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.pdrLabour'"
                    [formControlName]="'pdrLabourAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.carBodyLabour'"
                    [formControlName]="'carBodyLabourAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.additionalCosts'"
                    [formControlName]="'additionalCostsAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintLabour'"
                    [formControlName]="'paintLabourAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintMaterials'"
                    [formControlName]="'paintMaterialsAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">

                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountAmount'"
                    [formControlName]="'discountAmountAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.vatAmount'"
                    [formControlName]="'vatAmountAccepted'"
                    [settings]="{format:'n2',step:0.01,fxFill:true, readonly:true}">
                </numeric-input-ctrl>
            </div>
        </div>


        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.originalParts'"
                    [formControlName]="'originalPartsAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.alternativeParts'"
                    [formControlName]="'alternativePartsAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.normalies'"
                    [formControlName]="'normaliesAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountForParts'"
                    [formControlName]="'discountForPartsAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.netAmount'"
                    [formControlName]="'acceptedAmount'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.deductibleAmount'"
                    [formControlName]="'deductibleAmountAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkAcceptedCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.finalNetAmount'"
                    [formControlName]="'finalNetAmountAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.grosAmount'"
                    [formControlName]="'grosAmountAccepted'" [settings]="{format:'n2',step:0.01,fxFill:true}">
                </numeric-input-ctrl>
            </div>

        </div>
    </div>

    <div fxFill fxLayout="column" fxLayoutGap="10px" class="form-block">

        <div>
            <checkbox-input-ctrl [caption]="'claims-center.claimCostEstimations.isInvoicePartialNeeded'"
                [formControlName]="'isInvoicePartialNeeded'" (valueChangeEvent)="isInvoicePartialNeededChanged($event)">
            </checkbox-input-ctrl>
        </div>

        <div *ngIf="form.controls['isInvoicePartialNeeded'].value" fxLayout="row" fxLayoutGap="10px"
            fxLayoutAlign="start center">

            <div>
                <strong>
                    {{'claims-center.claimCostEstimations.costEstimationForInvoicePartialValues' | translate}}
                    <span class="k-text-warning" *ngIf="forInvoicePartialNetCheckResult?.mismatch">
                        {{'claims-center.claimCostEstimations.nettoValueIsDifferentThanSum' | translate}}
                        ({{'claims-center.claimCostEstimations.net' | translate}}: {{
                        forInvoicePartialNetCheckResult.netValue |
                        number : '1.2-2' }}
                        {{'claims-center.claimCostEstimations.sum' | translate}}:
                        {{forInvoicePartialNetCheckResult.netSumValue |
                        number : '1.2-2' }})
                    </span>
                </strong>
                <button type="button" kendoButton (click)="copyForInvoicePartialValues()" icon="copy" size="'small'"
                    look="flat"> </button>
                <button type="button" kendoButton (click)="cleanForInvoicePartialValues()" icon="close" size="'small'"
                    look="flat"> </button>
            </div>
        </div>

        <div *ngIf="form.controls['isInvoicePartialNeeded'].value" fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px"
            fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.pdrLabour'"
                    [formControlName]="'pdrLabourForInvoicePartial'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.carBodyLabour'"
                    [formControlName]="'carBodyLabourForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.additionalCosts'"
                    [formControlName]="'additionalCostsForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintLabour'"
                    [formControlName]="'paintLabourForInvoicePartial'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintMaterials'"
                    [formControlName]="'paintMaterialsForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">

                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountAmount'"
                    [formControlName]="'discountAmountForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.vatAmount'"
                    [formControlName]="'vatAmountForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true,readonly:true}">
                </numeric-input-ctrl>
            </div>
        </div>


        <div *ngIf="form.controls['isInvoicePartialNeeded'].value" fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px"
            fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.originalParts'"
                    [formControlName]="'originalPartsForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.alternativeParts'"
                    [formControlName]="'alternativePartsForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.normalies'"
                    [formControlName]="'normaliesForInvoicePartial'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountForParts'"
                    [formControlName]="'discountForPartsForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.netAmount'"
                    [formControlName]="'netAmountForInvoicePartial'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.deductibleAmount'"
                    [formControlName]="'deductibleAmountForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoicePartialCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.finalNetAmount'"
                    [formControlName]="'finalNetAmountForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true, readonly:true}">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.grosAmount'"
                    [formControlName]="'grosAmountForInvoicePartial'"
                    [settings]="{format:'n2',step:0.01,fxFill:true,readonly:true}">
                </numeric-input-ctrl>
            </div>
        </div>

    </div>

    <div fxFill fxLayout="column" fxLayoutGap="10px" class="form-block">

        <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center">
            <strong>
                {{'claims-center.claimCostEstimations.costEstimationForInvoiceValues' | translate}}
                <span class="k-text-warning" *ngIf="forInvoiceNetCheckResult?.mismatch">
                    {{'claims-center.claimCostEstimations.nettoValueIsDifferentThanSum' | translate}}
                    ({{'claims-center.claimCostEstimations.net' | translate}}: {{ forInvoiceNetCheckResult.netValue |
                    number : '1.2-2' }}
                    {{'claims-center.claimCostEstimations.sum' | translate}}: {{forInvoiceNetCheckResult.netSumValue |
                    number : '1.2-2' }})
                </span>
            </strong>
            <button type="button" kendoButton (click)="copyForInvoiceValues()" icon="copy" size="'small'" look="flat">
            </button>

            <button type="button" kendoButton (click)="calculateForInvoiceValues()" icon="calculator" size="'small'"
                look="flat">
            </button>
        </div>

        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <checkbox-input-ctrl [caption]="'claims-center.claimCostEstimations.forInvoiceConfirmation'"
                [formControlName]="'forInvoiceConfirmation'" (valueChangeEvent)="forInvoiceConfirmationChanged()">
            </checkbox-input-ctrl>
            <span class="small-info" *ngIf="costEstimation.forInvoiceConfirmedBy">
                ( {{costEstimation.forInvoiceConfirmedBy}} - {{costEstimation.forInvoiceConfirmationDate |
                date:'yyyy-MM-dd HH:mm'}} )
            </span>

            <span class="error-label" *ngIf="ongoingRepairWarning">
                {{'claims-center.claimCostEstimations.ongoingRepairWarning' | translate}}
            </span>

        </div>

        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.pdrLabour'"
                    [formControlName]="'pdrLabourForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.carBodyLabour'"
                    [formControlName]="'carBodyLabourForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.additionalCosts'"
                    [formControlName]="'additionalCostsForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintLabour'"
                    [formControlName]="'paintLabourForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.paintMaterials'"
                    [formControlName]="'paintMaterialsForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">

                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountAmount'"
                    [formControlName]="'discountAmountForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.vatAmount'"
                    [formControlName]="'vatAmountForInvoice'"
                    [settings]="{format:'n2',step:0.01,fxFill:true,readonly:true}">
                </numeric-input-ctrl>
            </div>
        </div>


        <div fxFlex="98" fxLayout="row wrap" fxLayoutGap="10px" fxLayout.lt-sm="column">
            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.originalParts'"
                    [formControlName]="'originalPartsForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.alternativeParts'"
                    [formControlName]="'alternativePartsForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100" class="normalies-field">
                <kendo-icon  kendoButton class="normalies-calc" [name]="'calculator'"
                    (click)="calculateNormaliesForInvoice()"></kendo-icon>
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.normalies'"
                    [formControlName]="'normaliesForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.discountForParts'"
                    [formControlName]="'discountForPartsForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.netAmount'"
                    [formControlName]="'netAmountForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.deductibleAmount'"
                    [formControlName]="'deductibleAmountForInvoice'" [settings]="{format:'n2',step:0.01,fxFill:true}"
                    (valueChangeEvent)="checkForInvoiceCostEstimationValues()">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.finalNetAmount'"
                    [formControlName]="'finalNetAmountForInvoice'"
                    [settings]="{format:'n2',step:0.01,fxFill:true,readonly:true}">
                </numeric-input-ctrl>
            </div>

            <div fxFlex="11" fxFlex.lt-sm="100">
                <numeric-input-ctrl [caption]="'claims-center.claimCostEstimations.grosAmount'"
                    [formControlName]="'grosAmountForInvoice'"
                    [settings]="{format:'n2',step:0.01,fxFill:true,readonly:true}">
                </numeric-input-ctrl>
            </div>
        </div>
    </div>



    <div *ngIf="editMode" fxLayoutGap="10px" class="form-block">
        <app-show-documents-multiple [referenceType]="costEstimationReferenceType" [referenceId]="costEstimation.id"
            [allowUpload]="false"></app-show-documents-multiple>
    </div>

    <div fxLayout="row" *ngIf="showMarkers">

        <div fxLayout="column" fxFlex="60" fxLayoutGap="5px">
            <div fxLayout="column" fxLayoutGap="10px" class="form-block">
                <app-attach-documents [formControlName]="'filesToAttach'"></app-attach-documents>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="10px" class="form-block">
                <div fxFill fxLayoutGap="10px">
                    <textarea-input-ctrl [caption]="'claims-center.claimCostEstimations.remarks'"
                        [formControlName]="'remarks'" [settings]="{rows:2,fxFill:true}"></textarea-input-ctrl>
                </div>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="10px" class="form-block" fxLayout.lt-sm="column">
                <app-cost-estimation-parts [costEstimationParts]="costEstimationParts"></app-cost-estimation-parts>
            </div>
        </div>

        <div fxLayout="column" fxFlex="40" fxLayoutGap="5px">
             <app-claim-markers-for-cost-estimation
                [claimIdentifier]="costEstimation.claimIdentifier"
                [pdrLabourInvoicedPartially]="form.controls['pdrLabourForInvoicePartial'].value"
                [pdrLabourInvoicedFinally]="form.controls['pdrLabourForInvoice'].value"
                [partsOriginalInvoicedPartially]="form.controls['originalPartsForInvoicePartial'].value"
                [partsOriginalInvoicedFinally]="form.controls['originalPartsForInvoice'].value"
                [partsAlternativeInvoicedPartially]="form.controls['alternativePartsForInvoicePartial'].value"
                [partsAlternativeInvoicedFinally]="form.controls['alternativePartsForInvoice'].value"
                [partsDiscountPartially]="form.controls['discountForPartsForInvoicePartial'].value"
                [partsDiscountFinally]="form.controls['discountForPartsForInvoice'].value"
                [normaliesInvoicedPartially]="form.controls['normaliesForInvoicePartial'].value"
                [normaliesInvoicedFinally]="form.controls['normaliesForInvoice'].value"
            ></app-claim-markers-for-cost-estimation>
        </div>
    </div>

    <div fxLayout="column" *ngIf="!showMarkers">
        <div fxLayout="column" fxLayoutGap="10px" class="form-block">
                <app-attach-documents [formControlName]="'filesToAttach'"></app-attach-documents>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="10px" class="form-block">
                <div fxFill fxLayoutGap="10px">
                    <textarea-input-ctrl [caption]="'claims-center.claimCostEstimations.remarks'"
                        [formControlName]="'remarks'" [settings]="{rows:2,fxFill:true}"></textarea-input-ctrl>
                </div>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="10px" class="form-block" fxLayout.lt-sm="column">
                <app-cost-estimation-parts [costEstimationParts]="costEstimationParts"></app-cost-estimation-parts>
            </div>
    </div>

</div>

<div kendoDialogContainer #costEstimationFormDialogContainer></div>